import { Routes } from "@angular/router";
import { sikkerInnsendingRoutes } from "./senddokument/sikkerInnsendingRoutes";
import { NotFoundComponent } from "@husbanken/designsystem-angular-core";
import { IsAuthenticated } from "./shared/guards/auth.guard";

export const appRoutes: Routes = [
  {
    path: "",
    children: sikkerInnsendingRoutes,
    canActivate: [IsAuthenticated],
  },
  {
    path: "**",
    component: NotFoundComponent,
  },
];
